<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import { useRoute } from "vue-router";
import { computed } from "vue";
import { usePracticeDetail } from "@/composables/models/practice/usePracticeMe";
import { useAbility } from "@casl/vue";
import PracticeAddEditForm from "@/components/models/practice/forms/PracticeAddEditForm.vue";

definePage({
  meta: {
    title: "generic.action.editEntity",
    titleParams: { entity: "generic.entity.practice" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return (
        can($permActions.UPDATE, $permSubjects.PRACTICE__PRACTICE) ||
        can($permActions.PRACTICE_ME_EDIT, $permSubjects.PRACTICE__PRACTICE)
      );
    },
  },
});

const route = useRoute();
const practiceId = computed(() => (route.params as { id: string }).id);
const useMe = computed(() => route.query.scope === "me");
const { data: defaultValues, isLoading } = usePracticeDetail(
  { id: practiceId },
  { useMe, redirectOnNotFound: true }
);

const formForWhatType = computed(() => route.query.type as "gp" | "ortho");
</script>

<template>
  <v-skeleton-loader :loading="isLoading">
    <PracticeAddEditForm
      :formForWhatType="formForWhatType"
      :defaultValues
    />
  </v-skeleton-loader>
</template>

<style scoped></style>
